/* Copyright (c) 2017 Backpack Health LLC */

import { connect } from 'react-redux';

import ProfilePhotoCrop from './ProfilePhotoCrop';
import PhotoModel from '../../../../models/PhotoModel';
import FileUploadBundle from '../../../../models/FileUploadBundle';
import { getPendingChanges, getActiveProfile } from '../../redux/reduxSelectors';
import NavigationActions from '../../redux/NavigationActions';
import ProfileActions from '../../redux/ProfileActions';

function mapStateToProps(state, routerProps) {
  const history = routerProps.history;
  const profile = getActiveProfile(state);
  const pendingData = getPendingChanges(state);
  const fileBundle = new FileUploadBundle(pendingData.data);
  const photo = new PhotoModel(fileBundle.data.file);
  const profileId = profile.data.id;

  return {
    photo,
    profileId,
    actions: {
      onUploadedPhoto: () => {
        ProfileActions.api.getProfile(profileId);
        NavigationActions.goBack(history);
      },
      onCancelPhoto: () => {
        NavigationActions.goBack(history);
      },
    },
  };
}

export default connect(mapStateToProps)(ProfilePhotoCrop);
